import { createSelector } from 'reselect';
import mappings from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.imCalculation.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getRows = state => (
    state.imCalculation.rows
);

export const getCsas = state => (
    state.imCalculation.csas
);

export const getInitialised = state => (
    state.imCalculation.initialised
);

export const getLoading = state => (
    state.imCalculation.loading
);

export const getCurrentServerFilters = state => (
    state.imCalculation.currentServerFilters
);

export const getDefaultFilters = state => (
    state.imCalculation.defaultFilters
);

export const getFilterDefinitions = state => (
    state.imCalculation.filterDefinitions
);
